import React from "react";
import { presets } from "../../theme/presets";
import { fontOptions } from "../../theme/defaultTheme";

const COLOR_FIELDS = [
  ["primary", "Ana renk"],
  ["accent", "Vurgu"],
  ["dark", "Koyu zemin"],
  ["bg", "Sayfa zemini"],
  ["surface", "Kart zemini"],
  ["text", "Metin"],
  ["muted", "Soluk metin"],
  ["border", "Kenarlık"],
];

const ThemeEditor = ({ theme, onChange }) => {
  const setColor = (k, v) => onChange({ ...theme, colors: { ...theme.colors, [k]: v } });
  const fontIdx = fontOptions.findIndex((f) => f.heading === theme.fonts.heading && f.body === theme.fonts.body);

  return (
    <>
      <div>
        <h3>Hazır temalar</h3>
        <p className="muted" style={{ fontSize: ".85rem", margin: "4px 0 12px" }}>Bir tema seçin, ardından renkleri tek tek ayarlayın.</p>
        <div className="preset-grid">
          {presets.map((p) => (
            <button type="button" key={p.id} aria-pressed={theme.preset === p.id} onClick={() => onChange({ ...p.theme })}>
              <div className="swatches">
                {["primary", "accent", "dark", "bg"].map((k) => (
                  <i key={k} style={{ background: p.theme.colors[k] }} />
                ))}
              </div>
              <strong>{p.label}</strong>
              <small>{p.description}</small>
            </button>
          ))}
        </div>
      </div>

      <div>
        <h3>Renkler</h3>
        <div className="color-grid mt-1">
          {COLOR_FIELDS.map(([k, label]) => (
            <div className="color-field" key={k}>
              <input type="color" id={`col-${k}`} value={theme.colors[k]} onChange={(e) => setColor(k, e.target.value)} />
              <div>
                <label htmlFor={`col-${k}`}>{label}</label>
                <code>{theme.colors[k]}</code>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="field">
        <label htmlFor="font-pair">Yazı tipi</label>
        <select
          id="font-pair"
          value={fontIdx === -1 ? "" : fontIdx}
          onChange={(e) => {
            const f = fontOptions[Number(e.target.value)];
            onChange({ ...theme, fonts: { heading: f.heading, body: f.body } });
          }}
        >
          {fontIdx === -1 && <option value="">Özel ({theme.fonts.heading} / {theme.fonts.body})</option>}
          {fontOptions.map((f, i) => (
            <option key={f.label} value={i}>
              {f.label}
            </option>
          ))}
        </select>
      </div>

      <div className="field">
        <label htmlFor="radius">Köşe yuvarlaklığı: {theme.radius}px</label>
        <input id="radius" type="range" min={0} max={28} step={1} value={theme.radius} onChange={(e) => onChange({ ...theme, radius: Number(e.target.value) })} />
      </div>

      <div className="field">
        <label>Üst menü</label>
        <div style={{ display: "flex", gap: 8 }}>
          {[
            ["light", "Açık"],
            ["dark", "Koyu"],
          ].map(([v, l]) => (
            <button
              type="button"
              key={v}
              className={`btn btn--sm ${theme.headerStyle === v ? "btn--primary" : "btn--outline"}`}
              onClick={() => onChange({ ...theme, headerStyle: v })}
            >
              {l}
            </button>
          ))}
        </div>
      </div>
    </>
  );
};

export default ThemeEditor;
